import {buildCloudinaryImageUrl} from '../../../../../../utils/CloudinaryImageUrl';

const fmt = (n) => '$' + Number(n || 0).toFixed(2);

const IcoChevron = ({ dir = 'down' }) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    style={{ transform: dir === 'up' ? 'rotate(180deg)' : 'none', transition: 'transform .25s' }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default function MobileCartBanner({
  items,
  subtotal = 0,
  itbms = 0,
  shipCost = 0,
  total = 0,
  onOpen
}) {
  const calculatedSubtotal = items.reduce((s, i) => s + Number(i.price || 0) * Number(i.qty || 0), 0);
  const displaySubtotal = Number(subtotal || calculatedSubtotal);
  const displayItbms = Number(itbms || 0);
  const displayShipCost = Number(shipCost || 0);
  const displayTotal = Number(total || (displaySubtotal + displayItbms + displayShipCost));
  const totalQty = items.reduce((s, i) => s + Number(i.qty || 0), 0);

  return (
    <div className="ck-mob-cart-banner">
      <div className="ck-mob-cart-card" onClick={onOpen}>
        <div className="ck-mob-cart-thumbs">
          {items.slice(0, 3).map(item => (
            <div key={item.id} className="ck-mob-thumb">
              <img src={buildCloudinaryImageUrl({url:item.img, width: 300,  quality: "auto", type: "image"})} alt={item.name} onError={e => e.target.style.opacity = 0} />
            </div>
          ))}
        </div>
        <div className="ck-mob-cart-info">
          <p className="ck-mob-cart-line1">Ver pedido</p>
          <p className="ck-mob-cart-line2">{totalQty} {totalQty === 1 ? 'producto' : 'productos'}</p>
        </div>
        <span className="ck-mob-cart-total">{fmt(displayTotal)}</span>
        <div className="ck-mob-cart-chevron">
          <IcoChevron dir="down" />
        </div>
      </div>
    </div>
  );
}
